import { useQuery } from '@tanstack/react-query';
import { AffiliateService } from '@/services/AffiliateService';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { Invitation } from '@/types/Invitation/Invitation';

function useInvites() {
  const selectedAffiliate = useSelector((state: any) => state.affiliate.selectedAffiliate);

  const fetchInvites = async ({
    queryKey,
  }: {
    queryKey: [string, string];
  }): Promise<Invitation[]> => {
    const [, affiliateId] = queryKey;
    if (!affiliateId) return [];
    return AffiliateService.getInvites(affiliateId);
  };

  const queryKey = useMemo(() => ['invites', selectedAffiliate?.id], [selectedAffiliate?.id]);

  const {
    data: invites = [],
    isLoading: invitesIsLoading,
    refetch,
  } = useQuery<Invitation[]>({
    queryKey,
    queryFn: fetchInvites,
    enabled: Boolean(selectedAffiliate?.id),
  });

  return { invites, invitesIsLoading, refetch };
}

export { useInvites };
